/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Dup_Receipt_ConfirmInputs */

const vi_customer_debt_dup_receipt_confirm = /** @type {(inputs: Customer_Debt_Dup_Receipt_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vẫn tạo`)
};

/**

* @param {Customer_Debt_Dup_Receipt_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_dup_receipt_confirm = /** @type {((inputs?: Customer_Debt_Dup_Receipt_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Dup_Receipt_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_dup_receipt_confirm(inputs)
});